export default __webpack_public_path__ + "static/media/pattern9.96565e83.png";